/** Simple client-side proxy for the NDC API. Allows for
 * easy calling of the REST services, and also converts
 * response types to immutable data structures.
 */

import { fromJS, List, Map } from 'immutable';

/** TODO: Inject into API functions */
// const baseUri = "https://mokajava.com/rest-services";
const baseUri = "https://dev.mokajava.com/rest-services";
// const baseUri = 'http://localhost:8199/services';

/** Returns a promise that resolves to the offerResponse
 * containing the given offer (by URI), and an Immutable Map.
 */
export const getOfferResponseByOffer = (offerURI) => {
  const url = new URL(`${baseUri}/persistence/retrieveOffersResponseAssociatedWithOffer`);
  url.searchParams.append('offerURI', offerURI);

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
  // // Local mock
  // return Promise.resolve(
  //     fromJS(
  //         require('../test/resources/samples/getOffersResponseFarelogixLufthansa.json')))
};

/** Returns a promise that resolves to the offerResponse
 * containing the given offer (by URI), and an Immutable Map.
 */
export const getOfferResponse = (offersResponseURI) => {
  const url = new URL(`${baseUri}/persistence/retrieveOffersResponse`);
  url.searchParams.append('offersResponseURI', offersResponseURI);

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
  // // Local mock
  // return Promise.resolve(
  //   fromJS(
  //       require('../test/resources/samples/getOffersResponseNew_usinguri.json')))
};

export const settleInvoice = (settleInvoiceRequest) => {
  // // Local mock

  // return Promise.resolve( fromJS(require("../test/resources/samples/settleInvoice.json")));

  const url = new URL(`${baseUri}/payment/settleInvoice`);
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(settleInvoiceRequest),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
};

/** Return airports info for all the given IATA codes */
export const getAirportsByIataCodes = (iataCodes = Set()) => {
  // if (iataCodes.isEmpty()) {
  //   return [];
  // }
  const url = new URL(`${baseUri}/airports/getAirportsByIATACode`);
  iataCodes.forEach((iataCode) => url.searchParams.append('iataCode', iataCode));

  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
  // Local mock
  // return Promise.resolve(
  //     fromJS(
  //         require('../test/resources/samples/getAirportsByIataResponse.json')))
};

/** Gets travel offers, given a travel request.
 * @param getOffersRequest A JSON-serializable (usaully, Immutable Map) representing a GetOffersRequest
 */
export const getOffers = (getOffersRequest) => {
  // // Local mock
  // // var mocked = fromJS(require("../test/resources/samples/getOffersResponse.json"));
  // // console.log(mocked);
  // // return Promise.resolve(mocked);

  // return Promise.resolve(
  //   fromJS(
  //       require('../test/resources/samples/getOffersResponseFarelogixLufthansa.json')))

  const url = new URL(`${baseUri}/shopping/getOffers`);
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(getOffersRequest),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
};

/**
 * Finds airport by name, with a global cache (airports don't change frequently...)
 * @param {*} query e.g "johan" for "Johannesburg"
 */
export const findAirportsByName = (query) =>
  query && airportsByQuery.has(query.toLowerCase())
    ? Promise.resolve(airportsByQuery.get(query.toLowerCase()))
    : fetch(new URL(`${baseUri}/airports/by-name/${encodeURIComponent(query)}`), {
        method: 'GET',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then(fromJS)
        .then((airports = List()) => {
          // Update cache
          // TODO: Better cache, with max size perhaps?
          airportsByQuery = airportsByQuery.set(query.toLowerCase(), airports);
          return airports;
        });

let airportsByQuery = Map();

/** Creates order for given offers
 * @param createOrderRequest A JSON-serializable (usaully, Immutable Map) representing a CreateOrderRequest
 */
export const createOrder = (createOrderRequest) => {
  // // Local mock

  // var mocked = fromJS(require("../test/resources/samples/createOrderResponse.json"));
  // console.log(mocked);
  // return Promise.resolve(mocked);

  const url = new URL(`${baseUri}/ordering/createOrder`);
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(createOrderRequest),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
};

/** Tries to create a ticket on the agency's CRM system. */
export const createBookingTicket = (createBookingTicketRequest) => {
  const url = new URL(`${baseUri}/ticketing/addTicket`);
  console.log(JSON.stringify(createBookingTicketRequest));
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(createBookingTicketRequest),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
};

let locationByQuery = Map();
/**
 * Finds locations by name, with a global cache - can consider to move this server side (caching)
 * @param {*} query e.g "lond" for "London"
 */
export const findLocationByName = (query) =>
  query && locationByQuery.has(query.toLowerCase())
    ? Promise.resolve(locationByQuery.get(query.toLowerCase()))
    : fetch(new URL(`${baseUri}/location/by-name/${encodeURIComponent(query)}`), {
        method: 'GET',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then(fromJS)
        .then((locationResults = List()) => {
          // Update cache
          // TODO: Better cache, with max size perhaps?
          locationByQuery = locationByQuery.set(query.toLowerCase(), locationResults);
          return locationResults;
        });

let locationDetailByQuery = Map();
/**
 * Find GPS Coordinates for a given Location Identifier (for cases where findLocationByName doesn't return the coordinates)
 * @param {*} id e.g "lond" for "London"
 */
export const findLocationDetailByID = (id) =>
  id && locationDetailByQuery.has(id)
    ? Promise.resolve(locationDetailByQuery.get(id))
    : fetch(new URL(`${baseUri}/location/detail/${encodeURIComponent(id)}`), {
        method: 'GET',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then(fromJS)
        .then((geoLocation = List()) => {
          // Update cache
          // TODO: Better cache, with max size perhaps?
          locationDetailByQuery = locationDetailByQuery.set(id, geoLocation);
          return geoLocation;
        })
        .catch((error) => {
          console.log(error.toString());
          return null;
        });

/** Return accommodation details for all the given accommodation ID */
export const getAccommodationSummary = (ids = Set()) => {
  const url = new URL(`${baseUri}/accommodation/summary`);
  ids.forEach((id) => url.searchParams.append('id', id));
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
};

/** Return roles for the given Auth0 user id */
export const getAuth0UserRoles = ( id ) => {
  const url = new URL(`${baseUri}/transend/getUserRoles`);
  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify( { userId: id} ),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then((response) => response.json())
    .then(fromJS);
};



// WEBPACK FOOTER //
// ./src/ndc/api.js